export default {
  "transferFeedback.transferRoutes.0": "Forbidden",
  "transferFeedback.transferRoutes.2": "Unable to list paired instances",
  "transferFeedback.transferRoutes.3": "Invalid label",
  "transferFeedback.transferRoutes.5": "Unable to set the instance label",
  "transferFeedback.transferRoutes.6": "Unable to read advertise settings",
  "transferFeedback.transferRoutes.7": "Invalid dashboard URL",
  "transferFeedback.transferRoutes.9": "Unable to set the dashboard URL",
  "transferFeedback.transferRoutes.10": "Invalid origin",
  "transferFeedback.transferRoutes.12": "Unable to advertise the dashboard URL",
  "transferFeedback.transferRoutes.15": "Unable to create share",
  "transferFeedback.transferRoutes.16": "Invalid share id",
  "transferFeedback.transferRoutes.17": "Transfer not found",
  "transferFeedback.transferRoutes.18": "Unable to load transfer status",
  "transferFeedback.transferRoutes.19": "Unable to load transfer status",
  "transferFeedback.transferRoutes.20": "Unable to load incoming transfers",
  "transferFeedback.transferRoutes.21": "Unable to load outgoing transfers",
  "transferFeedback.transferRoutes.22": "Invalid query parameters",
  "transferFeedback.transferRoutes.23": "Unable to load transfer history",
  "transferFeedback.transferRoutes.24": "Transfer not found",
  "transferFeedback.transferRoutes.25": "Unable to load transfer detail",
  "transferFeedback.transferRoutes.26": "Unable to load transfer detail",
  "transferFeedback.transferRoutes.27": "Invalid share id",
  "transferFeedback.transferRoutes.29": "Unable to delete the transfer history record",
  "transferFeedback.transferRoutes.30": "Unable to clear transfer history",
  "transferFeedback.transferRoutes.31": "Unable to load transfer settings",
  "transferFeedback.transferRoutes.32": "Invalid settings",
  "transferFeedback.transferRoutes.33": "Unable to update transfer settings",
  "transferFeedback.transferRoutes.34": "Unable to load transfer peers",
  "transferFeedback.transferRoutes.35": "Invalid peer IP",
  "transferFeedback.transferRoutes.36": "Unable to remove peer",
  "transferFeedback.transferRoutes.37": "Unable to remove transfer peer",
  "transferFeedback.transferRoutes.38": "Invalid request body",
  "transferFeedback.transferRoutes.40": "Unable to approve transfer",
  "transferFeedback.transferRoutes.41": "Share not found",
  "transferFeedback.transferRoutes.42": "Unable to reject transfer",
  "transferFeedback.transferRoutes.44": "Unable to start transfer",
  "transferFeedback.transferRoutes.45": "Transfer not found",
  "transferFeedback.transferRoutes.46": "Unable to load transfer status",
  "transferFeedback.transferRoutes.47": "Transfer is not in a transferring state",
  "transferFeedback.transferRoutes.48": "Unable to update transfer",
  "transferFeedback.transferRoutes.49": "Invalid throttle value",
  "transferFeedback.transferRoutes.50": "Transfer is not in a transferring state",
  "transferFeedback.transferRoutes.51": "Unable to update throttle",
  "transferFeedback.transferRoutes.52": "Share not found",
  "transferFeedback.transferRoutes.53": "Unable to cancel transfer",
  "transferFeedback.transferRoutes.54": "Invalid request body",
  "transferFeedback.transferRoutes.56": "Unable to reclaim the transfer source",
  "transferFeedback.transferRoutes.58": "Unable to apply ownership to the delivery",
  "transferFeedback.transferRoutes.59": "Invalid request body",
  "transferFeedback.transferRoutes.60": "Forbidden",
  "transferFeedback.transferRoutes.63": "User not found",
  "transferFeedback.transferRoutes.65": "Unable to browse",
  "transferFeedback.transferFeatureGuard.66": "Inter-instance transfer is not enabled",
  "transferFeedback.shareService.67": "Transfers are disabled in demo mode.",
  "transferFeedback.shareService.68": "Owner not found",
  "transferFeedback.shareService.69": "This instance is not activated",
  "transferFeedback.shareService.70": "The transfer identity is unavailable on this server, so the offer cannot be created. Restart the transfer daemon and try again.",
  "transferFeedback.shareService.71": "This selection is already being prepared.",
  "transferFeedback.shareService.73": "Share not found",
  "transferFeedback.shareService.74": "Forbidden",
  "transferFeedback.shareService.75": "Destination must be absolute",
  "transferFeedback.shareService.76": "Destination path is not accessible",
  "transferFeedback.shareService.77": "Invalid destination path",
  "transferFeedback.shareService.78": "Recipient user does not exist on this server",
  "transferFeedback.shareService.79": "Forbidden",
  "transferFeedback.shareService.80": "Owner user does not exist on this server",
  "transferFeedback.shareService.81": "Not enough free space for this transfer",
  "transferFeedback.shareService.82": "Owner not found",
  "transferFeedback.shareService.83": "Share is not approved or not found",
  "transferFeedback.shareService.84": "A transfer is already in progress for this share",
  "transferFeedback.shareService.86": "Grant scope does not match the share",
  "transferFeedback.shareService.87": "Grant was not issued for this instance",
  "transferFeedback.shareService.88": "Grant recipient does not match the share",
  "transferFeedback.shareService.89": "Recipient user does not exist on this server",
  "transferFeedback.shareService.96": "Transfer not found",
  "transferFeedback.shareService.97": "This transfer is still active. Cancel it before deleting its history.",
  "transferFeedback.shareService.98": "Share not found",
  "transferFeedback.shareService.99": "Only a migration transfer can reclaim its source",
  "transferFeedback.shareService.100": "This transfer is not complete",
  "transferFeedback.shareService.101": "This transfer has no broker offer to confirm against",
  "transferFeedback.shareService.102": "Completion could not be confirmed with the transfer broker — the source was kept.",
  "transferFeedback.shareService.103": "Share not found",
  "transferFeedback.shareService.104": "This transfer did not deliver to a system destination",
  "transferFeedback.shareService.105": "This transfer is not complete",
  "transferFeedback.shareService.106": "No owner is set for this delivery",
  "transferFeedback.shareService.107": "Owner user does not exist on this server",
  "transferFeedback.brokerClient.109": "This instance is not licensed/activated",
  "transferFeedback.brokerClient.111": "Broker unreachable",
  "transferFeedback.brokerClient.112": "This instance is not licensed/activated",
  "transferFeedback.brokerClient.114": "Broker unreachable",
  "transferFeedback.brokerClient.115": "This instance is not licensed/activated",
  "transferFeedback.brokerClient.117": "Broker unreachable",
  "transferFeedback.brokerClient.118": "This instance is not licensed/activated",
  "transferFeedback.brokerClient.120": "Broker unreachable",
  "transferFeedback.brokerClient.121": "This instance is not licensed/activated",
  "transferFeedback.brokerClient.123": "Broker unreachable",
  "transferFeedback.brokerClient.124": "This instance is not licensed/activated",
  "transferFeedback.brokerClient.126": "Broker unreachable",
  "transferFeedback.brokerClient.127": "This instance is not licensed/activated",
  "transferFeedback.brokerClient.129": "Broker unreachable",
  "transferFeedback.brokerClient.130": "This instance is not licensed/activated",
  "transferFeedback.brokerClient.132": "Broker unreachable",
  "transferFeedback.browsePolicy.133": "Path must be absolute",
  "transferFeedback.browsePolicy.134": "This location is restricted to the operator account",
  "transferFeedback.browsePolicy.135": "Forbidden",
  "transferFeedback.listDirService.136": "Invalid path",
  "transferFeedback.listDirService.137": "Path not found",
  "transferFeedback.listDirService.138": "Path not found",
  "transferFeedback.listDirService.140": "Not a directory",
  "transferFeedback.listDirService.141": "Unable to read directory",
  "transferFeedback.listDirService.142": "Path must be absolute",
  "transferFeedback.listDirService.143": "Path not found",
  "transferFeedback.listDirService.146": "Not a directory",
  "transferFeedback.listDirService.147": "Path not found",
  "transferFeedback.listDirService.148": "Unable to read directory",
  "transferFeedback.manifestPrepareService.149": "The manifest build could not start",
  "transferFeedback.manifestPrepareService.151": "The manifest build failed unexpectedly",
  "transferFeedback.manifestPrepareService.152": "The manifest build process exited abnormally",
  "transferFeedback.manifestPrepareService.153": "The manifest build ended without a result",
  "transferFeedback.manifestWorker.154": "Manifest build cancelled",
  "transferFeedback.manifestWorker.155": "Manifest build cancelled",
  "transferFeedback.manifestUnavailable": "Unable to build the file manifest",
  "transferFeedback.manifestLimit": "Manifest exceeds the {{limit}}-file limit",
  "transferFeedback.manifestUnexpected": "The manifest build failed unexpectedly",
  "transferFeedback.manifestEmpty": "No readable files in the selected paths",
  "transferFeedback.manifestRestart": "The dashboard restarted while this transfer was preparing. Please recreate it.",
  "transferFeedback.manifestStalled": "The manifest build stalled and was cleaned up. Please recreate the transfer.",
  "transferFeedback.startFailed": "Could not start the transfer: {{reason}}",
  "transferFeedback.daemonUnreachable": "The transfer daemon is not reachable",
  "transferFeedback.ownershipFailed": "Could not apply ownership",
  "transferFeedback.browseAbsolute": "Path must be absolute",
  "transferFeedback.browseRead": "Unable to read directory",
  "transferFeedback.brokerFallback.110": "Failed to register share with the broker",
  "transferFeedback.brokerFallback.113": "Failed to list incoming shares",
  "transferFeedback.brokerFallback.116": "Broker rejected the decision",
  "transferFeedback.brokerFallback.119": "Broker rejected the revoke",
  "transferFeedback.brokerFallback.122": "Failed to obtain a transfer grant",
  "transferFeedback.brokerFallback.125": "Failed to list paired instances",
  "transferFeedback.brokerFallback.128": "Failed to set the instance label",
  "transferFeedback.brokerFallback.131": "Failed to advertise the dashboard URL",
  "transferFeedback.selectionTooLarge": "Selection too large; reduce the number or length of selected paths."
} as const;
